
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqz19qZS4tpKS_bXvIMr3WGnHoDMQ5FWI_O4CrCoIFbXoMeta } from "/codebuild/output/src3828658806/src/src/pages/faq.vue?macro=true";
import { default as menu0yok20bHFW4fbjuQ_UJ2wleCjThBqNAti_yVpVC0UH4Meta } from "/codebuild/output/src3828658806/src/src/pages/menu.vue?macro=true";
import { default as indexwPsckuFjiT3UiZd3lKbEsheKra7heXbRpPFcPWkvO8MMeta } from "/codebuild/output/src3828658806/src/src/pages/index.vue?macro=true";
import { default as contact50_45rXG5eHfvUBpRu__eGuucPz87EVhOlwaZtVDaSWXkMeta } from "/codebuild/output/src3828658806/src/src/pages/contact.vue?macro=true";
import { default as tutorialuaNTetuwBiNAVdy38_45IO9_XLGUlv3lsAcLaKKAR03TwMeta } from "/codebuild/output/src3828658806/src/src/pages/tutorial.vue?macro=true";
import { default as agreementvSGj1jKPfOiOu8J_45mAyiRzX3ZmCc_45zLxx8CQbSoewyUMeta } from "/codebuild/output/src3828658806/src/src/pages/agreement.vue?macro=true";
import { default as about_45passMdkvhfM5pWH67G9RCCQMgwRkVSgsE8xJzCuXcL9g6QEMeta } from "/codebuild/output/src3828658806/src/src/pages/about-pass.vue?macro=true";
import { default as index_45ogygDazZpSC0tiwB8uNHD5mzp4FdtLetKRqOC0izsUMeta } from "/codebuild/output/src3828658806/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93dWh7vKIuD5fruYSZ_45etjxUfiJIpSsryHXjflED_459KOoMeta } from "/codebuild/output/src3828658806/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceKYOu9x1AoTG8cBDA0Tx_45GPicvfJBLWMvwlmxHYq3qZkMeta } from "/codebuild/output/src3828658806/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93Fphrs_452OBhLZFvYArXoDoGFaVeHwFiE5HZIukXMRoyYMeta } from "/codebuild/output/src3828658806/src/src/pages/notice/[id].vue?macro=true";
import { default as index0vj5FOlWxy1_alKpHn2810wMDWomIY79_45RVLy92_s9kMeta } from "/codebuild/output/src3828658806/src/src/pages/coupon/index.vue?macro=true";
import { default as indexOHjnIEqtsspVhEviwKjCbqaxrYk_U2rHex2PPFBCp5wMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/index.vue?macro=true";
import { default as indexG_orkxosDCfJau8_45EGophYJmRWV3RgMAweoME5gfG1UMeta } from "/codebuild/output/src3828658806/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93BKXKmIa7RMGhgrMDd_o5a0MEcgjm_45e4_JEzYig4EH1EMeta } from "/codebuild/output/src3828658806/src/src/pages/parking/[id].vue?macro=true";
import { default as indexX_EqXMTfNiK_45Eyuwp5OCFCrUCbztwdgImxHqNGeBpwkMeta } from "/codebuild/output/src3828658806/src/src/pages/history/index.vue?macro=true";
import { default as indexbf9WzKHm_MbmkDvG_45jIhsflJLSSaD5T7Hpmu6_45Y461EMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/index.vue?macro=true";
import { default as indexPDEDnEX7fkitqk7Jkfhqx93XL6ogom1kaDs9Ta5QfGoMeta } from "/codebuild/output/src3828658806/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexJckW7exK2vyYbj5beUCNZbaVjV7_4beboeBvBXwuY6wMeta } from "/codebuild/output/src3828658806/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviPRBKt29sMz6HzKkUs6Sqa1ecWl2KrMxpDH0v3ScbsocMeta } from "/codebuild/output/src3828658806/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editDB22iEoVh9HqkOmiV8yiVb5cv4xnvtUVT7ynwljeMqQMeta } from "/codebuild/output/src3828658806/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementp99OO3OXesQNh5Ug1_45tWQaYAja17QajA3ALxIQQ46qMMeta } from "/codebuild/output/src3828658806/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexXtKog_45uiDJ30J5TuUDccoj9g4OoTkPgDDrJNPx8bb3YMeta } from "/codebuild/output/src3828658806/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dZQqicSH1wU4COs1_uUHGRD_45r2IvnI2qeH_06_YAKyKwMeta } from "/codebuild/output/src3828658806/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirm_45vs9Gk0k5F2xDJBBCZgobp_c9B5flSVsM8G6_Wu7vQQMeta } from "/codebuild/output/src3828658806/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexLyh07J_4511oNt3JFPy3cqP5nHlhr3BNo_j0jmmE1ULB4Meta } from "/codebuild/output/src3828658806/src/src/pages/card/create/index.vue?macro=true";
import { default as indexHQi5ZMyLSzvJrqkz4s91ctwM_45eXbDlQpacqMeHJfiLoMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmEYH_45m2NuhvQKqI6RhtzD2tz8AoRUNIWNdU9_2AxZWIQMeta } from "/codebuild/output/src3828658806/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmpq_45lkS_45PqtH3ckxFIQ_455g7S6k9Uh8VoOnx7rjnt4dyMMeta } from "/codebuild/output/src3828658806/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeP1rQoOzjbTdRRd7CeEczZZyZglxmyWBaCwuFCcLWrcoMeta } from "/codebuild/output/src3828658806/src/src/pages/membership/complete.vue?macro=true";
import { default as registerM0XsoLsRdNR6xmhIXvONOe_gEm_asGMod8WIMA0JcicMeta } from "/codebuild/output/src3828658806/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93RH_CRx4I1N7L598_tdm_45CQMDhiQYp3T_S2nJce2nBwMMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmG_45X26u2HJWbmrLz8vkCxdHHHrmNCZ9DNQ7mF9_p1hsYMeta } from "/codebuild/output/src3828658806/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93bqmsQkd3RKDRsz7j_45uC3p3iR2QSH4tqaungJtEUwNpkMeta } from "/codebuild/output/src3828658806/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexcmZK2t_LFZ0aznj7dialCmLDYu3utKP0XPcrj7K9IQIMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeo9tUazPfWYvtlO4vqYpbq9M6FS5lI4Wxg_YWNl_XmzsMeta } from "/codebuild/output/src3828658806/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeY5MwyTOzB_458WNkMnGibgjSQslSbRjseG34yB0OX_45BW4Meta } from "/codebuild/output/src3828658806/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeIWTWJD_45MSOofzUtojg9CgePf70YQfidG_456sGVtTokUgMeta } from "/codebuild/output/src3828658806/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerdplPoMOzB8QeWjG8v_yFvpwzmMhHbliOHaVa1rK5iGEMeta } from "/codebuild/output/src3828658806/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeFcaY6eLjig7fQ7ySK3niAIt_iG6OpYN6pPgnGZu7rHcMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexTH5SGs8To0A8DPyQKWTys5SMSsBa2bT6uuj3J8kKJOUMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirm1eiJruKs9BfPlJj_5l8A6DkXdpHy6B0Kz4QlOKKoD6MMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completehnq_aRfztFVjVk0lgTdPdyJFEhf1wQf9o3CKh9WPlrEMeta } from "/codebuild/output/src3828658806/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexbjFCA0m0IxyUhzVDhhLxFccdpKlke_4560jHjCi9ocHO0Meta } from "/codebuild/output/src3828658806/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93mzN29rAUCGc_Hm7vzEHABrdJh1M0vlz7rU_82p5KkSMMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete5XTZipzJIvKmtgZSKSIWu5Vsfvv_45bcujBEcZ_GE3IZQMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasF0zDKKNN9_prWlQB1Fona33g589gdheNU874KiKbfxIMeta } from "/codebuild/output/src3828658806/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplexjQo8Q24zGS4WEEKfPNpqJ3h9Uovw_xQx_p5d_45LzYfYMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailypvZBcjgBtxF9T6sdVhsvpHmNKOMXddewhMsusm8Q0AMeta } from "/codebuild/output/src3828658806/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmGUSyWs_gWM9hMEH43bl0RmLagYbwqUx5zt0hs2QTWRgMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consentMwEByZyCePzuo8lIBA7j4oQU6Ua_45yKtAuHu52Vy8EbYMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmXE3Kke58BbCjuIN_KT1OJqzd5p5tPg4CK6_W9iA1ULUMeta } from "/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedate13AU6w_45EDn1qvbevp8WoEPdvG8Ht4fevf9Jb_454G6kWIMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completevG8eJXpkx5wUkHqgR6CUREnWlQ6vlpau8ohepzSslw8Meta } from "/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeCihSICwcylPxmvv7NHdhXRzYZYyjKESnZsxIJY93FR0Meta } from "/codebuild/output/src3828658806/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordDRlPSIZxn6_hVBUlLIdnz748_qtIEA_45TpBPK6nLvk8kMeta } from "/codebuild/output/src3828658806/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasngnCeCZX8ac6XLRzWjtA55zLC4ch9vQ8oGuhu8nxa4sMeta } from "/codebuild/output/src3828658806/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as register9L2lyee2lH2ThKRAvAx7EkqK7nO0bbQHVC7huzYmzH4Meta } from "/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeYlKAvXqbuMXgMiVophMQA_45NhlKF7m04GR6d3pqShpbkMeta } from "/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexKNoHDonpdESk6jko98XYf296S8ZfuYcuOZKFhvlTRoQMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexaedJiM66U5eE6MxeinmZr7_99eyHTgL0rr0oL4E_di0Meta } from "/codebuild/output/src3828658806/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexlXHAEq0RHOMfPQ2vPXICfBExr26K6prgZkK5emi8_454oMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as index5B0fFzKEJuJ0ntuu2_45Tz8OZip5HpJvH5Sy59ye3a7eMMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateVPgfCxWrLMzfcEf7xgcOzubcJY2TF_45JtEiqEWo9AyFsMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeNCKKvwUQ4E01GYPToS8IzT8FKCrOwEAx9DcNpomVF34Meta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmfofgPOhT6KdAv2iF4rS_iUWqN5tvxNDLQ3x1iYS4hloMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexHTBanfg_YtV_DpGKcgch9fyw0YSh5AmJIHp9d9SOQ1YMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeKIkvyjpwxwvLrA1jjMLhh_45MIozyia3VUgh_xW_45QgZJMMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as update0iENh_45dNseH8jvdQFX5gGLAwEa_454QFgG2f9_ksQ8mkIMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as index1IvGB6vo91fBHBxFeTda_MjeVe_CDXaDwwT6Sw1LVVsMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexENR4FhBXTampuEMEb_sMGDTw1Kce9Hb4BYtCT2K3c1UMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as complete9pB6vJoL3q9KGo5H4ViwHAS9b8j3eii8jpNuqxGCeN0Meta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexYVbJhbxKjIIpf8oIHTs1_45UvejF02BCgE2YJlXYKN6JgMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeHR5eSl8jPBKXtpt2I0si9CBigRIMxX3_45LO2fjt4zZBgMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexhbk2qcA3QR3LyhRaEg5ZBURPI8_HHphOHCydeRvMntUMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as index3w_45mzrf5klwPNfUwpimjwF9IQ7dv5_456Mx9HrlemW4NMMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexBLJikTrMVfpYRPgI5l7pQo63MYPXJDAX9_45TahHFLCSAMeta } from "/codebuild/output/src3828658806/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateZ01waBR2BqHTscUHJUBxZCaNdEo_45r4y3Sz2FU_45DxZQYMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmAyD5hBA_PI919t0MxhsMJZIh_45NXtZqt1a8BUjLHaeocMeta } from "/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu0yok20bHFW4fbjuQ_UJ2wleCjThBqNAti_yVpVC0UH4Meta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexwPsckuFjiT3UiZd3lKbEsheKra7heXbRpPFcPWkvO8MMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(index0vj5FOlWxy1_alKpHn2810wMDWomIY79_45RVLy92_s9kMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexX_EqXMTfNiK_45Eyuwp5OCFCrUCbztwdgImxHqNGeBpwkMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: indexPDEDnEX7fkitqk7Jkfhqx93XL6ogom1kaDs9Ta5QfGoMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexJckW7exK2vyYbj5beUCNZbaVjV7_4beboeBvBXwuY6wMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexLyh07J_4511oNt3JFPy3cqP5nHlhr3BNo_j0jmmE1ULB4Meta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmEYH_45m2NuhvQKqI6RhtzD2tz8AoRUNIWNdU9_2AxZWIQMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmpq_45lkS_45PqtH3ckxFIQ_455g7S6k9Uh8VoOnx7rjnt4dyMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeP1rQoOzjbTdRRd7CeEczZZyZglxmyWBaCwuFCcLWrcoMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerM0XsoLsRdNR6xmhIXvONOe_gEm_asGMod8WIMA0JcicMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmG_45X26u2HJWbmrLz8vkCxdHHHrmNCZ9DNQ7mF9_p1hsYMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeo9tUazPfWYvtlO4vqYpbq9M6FS5lI4Wxg_YWNl_XmzsMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeY5MwyTOzB_458WNkMnGibgjSQslSbRjseG34yB0OX_45BW4Meta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeIWTWJD_45MSOofzUtojg9CgePf70YQfidG_456sGVtTokUgMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerdplPoMOzB8QeWjG8v_yFvpwzmMhHbliOHaVa1rK5iGEMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirm1eiJruKs9BfPlJj_5l8A6DkXdpHy6B0Kz4QlOKKoD6MMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completehnq_aRfztFVjVk0lgTdPdyJFEhf1wQf9o3CKh9WPlrEMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexbjFCA0m0IxyUhzVDhhLxFccdpKlke_4560jHjCi9ocHO0Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete5XTZipzJIvKmtgZSKSIWu5Vsfvv_45bcujBEcZ_GE3IZQMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplexjQo8Q24zGS4WEEKfPNpqJ3h9Uovw_xQx_p5d_45LzYfYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailypvZBcjgBtxF9T6sdVhsvpHmNKOMXddewhMsusm8Q0AMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmGUSyWs_gWM9hMEH43bl0RmLagYbwqUx5zt0hs2QTWRgMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consentMwEByZyCePzuo8lIBA7j4oQU6Ua_45yKtAuHu52Vy8EbYMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmXE3Kke58BbCjuIN_KT1OJqzd5p5tPg4CK6_W9iA1ULUMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completevG8eJXpkx5wUkHqgR6CUREnWlQ6vlpau8ohepzSslw8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeCihSICwcylPxmvv7NHdhXRzYZYyjKESnZsxIJY93FR0Meta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordDRlPSIZxn6_hVBUlLIdnz748_qtIEA_45TpBPK6nLvk8kMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: register9L2lyee2lH2ThKRAvAx7EkqK7nO0bbQHVC7huzYmzH4Meta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeYlKAvXqbuMXgMiVophMQA_45NhlKF7m04GR6d3pqShpbkMeta || {},
    component: () => import("/codebuild/output/src3828658806/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3828658806/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]